import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { commonFieldSx } from "./dropdownStyles";

export default function AppYearPicker({
  label,
  value,
  onChange,
  disabled = false,
  fullWidth = false,
  sx,
  ...props
}) {
  const yearValue = value ? dayjs(`${value}-01-01`) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
      <DatePicker
        {...props}
        label={label}
        value={yearValue?.isValid() ? yearValue : null}
        onChange={(nextValue) => {
          onChange?.(nextValue?.isValid?.() ? nextValue.year() : "");
        }}
        views={["year"]}
        openTo="year"
        format="YYYY"
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth,
            size: "small",
            sx: {
              ...commonFieldSx,
              ...sx,
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}
